import { useState, useEffect } from 'react';
import Config from "../../../../config/config"
import CryptoJS from 'crypto-js';
import branch from 'branch-sdk'

const encrypt = (text: string) => {
    return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
};

// const decrypt = (data: string) => {
//     return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
// };

const KnownDeeplink = () => {
    const [installLink, setinstallLink] = useState('');
    // const location = useLocation();

    useEffect(() => {
        const _window: any = window
        if(_window.branch == undefined) {
            _window.branch = branch.init(Config.Branchio_key)
        }
        // eslint-disable-next-line no-undef
        _window.branch.init(Config.Branchio_key, (err:any, data:any) => {
            if (err) {}
            /* // let data: any = new URLSearchParams(location.search).get("data")
            // data = JSON.parse(data) */
            if(!!data) {
                const datatosend = {
                    webtoken: data.data_parsed.$webtoken,
                    sessiontype: data.data_parsed.$sessiontype,
                    pid: data.data_parsed.$pid
                }
                if(data.data_parsed.$sessiontype === "ASYNC" || data.data_parsed.$sessiontype === "REELS") {
                    setinstallLink(Config.DEV_ASYNK_URL + `/install/${data.data_parsed.$sessioncode}?email=${encodeURIComponent(decodeURIComponent(data.data_parsed.$email))}&data=${encrypt(JSON.stringify(datatosend))}`)
                }
                if(data.data_parsed.$sessiontype === "MOD" || data.data_parsed.$sessiontype === "MODERATED") {
                    setinstallLink(Config.DEV_MOD_URL + `/install/${data.data_parsed.$sessioncode}?email=${encodeURIComponent(decodeURIComponent(data.data_parsed.$email))}&data=${encrypt(JSON.stringify(datatosend))}`)
                }
            }
        })
    }, [])
    
    useEffect(() => {
        if(!!installLink) {
            window.location.href = installLink
        }
    }, [installLink])
    
    return (
        <h1></h1>
    )
};

export default KnownDeeplink;
